import { useEffect, useState } from 'react'

/**
 * useNow — a clock that ticks on a fixed interval.
 *
 * Returns the current time as ms-since-epoch and re-renders the consuming
 * component every `intervalMs`. Used by the Action Center to refresh the
 * Lead Time column every 10 minutes without polling the API.
 *
 * Default 10 min matches the Action Center spec (Lead Time accuracy in
 * hours; sub-10-min precision isn't useful and would just thrash renders).
 *
 * Example:
 *   const now = useNow(10 * 60 * 1000)
 *   const hours = leadTimeHours(action.event_at, now)
 */
export function useNow(intervalMs = 10 * 60 * 1000) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
